import { cn } from "@/lib/utils"

type NodePillTone = "scalar" | "connected" | "socket"

type NodePillProps = {
	children: React.ReactNode
	className?: string
	tone?: NodePillTone
	selected?: boolean
	paddingClassName?: string
	interactive?: boolean
}

function resolveBorderClassName(tone: NodePillTone, selected: boolean) {
	if (selected) {
		return "border-[var(--node-pill-border-active)]"
	}

	switch (tone) {
		case "connected":
			return "border-[var(--node-pill-border-connected)]"
		case "socket":
		case "scalar":
		default:
			return "border-[var(--node-pill-border)]"
	}
}

export function NodePill({
	children,
	className,
	tone = "scalar",
	selected = false,
	paddingClassName,
	interactive = false,
}: NodePillProps) {
	return (
		<span
			data-oblique-pill
			data-oblique-pill-tone={tone}
			className={cn(
				"relative inline-flex shrink-0 rounded-[20px] border-[3px] border-solid transition-[border-color,transform] duration-150",
				resolveBorderClassName(tone, selected),
				paddingClassName ??
					(tone === "socket" ? "p-[3px]" : "px-[12px] py-[4px]"),
				!selected && "hover:border-[var(--node-pill-border-hover)]",
				className,
			)}
			onPointerDown={
				interactive ? (event) => event.stopPropagation() : undefined
			}
			onClick={interactive ? (event) => event.stopPropagation() : undefined}
		>
			<span
				aria-hidden="true"
				className="absolute inset-0 rounded-[inherit] bg-[var(--node-pill-bg)]"
			/>
			<span className="relative z-10 flex items-center">{children}</span>
			<span
				aria-hidden="true"
				className="pointer-events-none absolute inset-0 z-20 rounded-[inherit] shadow-[var(--node-pill-shadow)]"
			/>
		</span>
	)
}
